import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/jornada-detalle';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getJornadasDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Jornada
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getJornadaDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Jornada
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postJornadaDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Jornada
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchJornadaDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Jornada
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteJornadaDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR jornadaDetalle
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarJornadaDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
